import React from 'react';
import styles from './NoResults.module.less';

const NoResults = () => (
  <p className={styles.noResults}>No results. Try a different phrase.</p>
);

export default NoResults;
